import { useEffect } from "react";
import Layout from '../utils/core/Layout';
import './CookiesPolicy.css'; // same stylesheet used by your other legal pages

const CancellationRefundPolicyPage = () => {

  useEffect(() => {
    // scroll only when the page URL contains #top
    if (window.location.hash === "#top") {
      const heading = document.querySelector(".policy-page");
      if (heading) {
        heading.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  return (
    <Layout>
      <div className="policy-page">
        <h1 className="policy-title">Refund & Cancellation Policy</h1>

        {/* Blue banner */}
        <div className="policy-banner">
          <p className="policy-banner-updated">
            <strong>Last Updated:</strong> 27/11/2025
          </p>
          <p className="policy-banner-text">
            PLEASE READ THIS REFUND & CANCELLATION POLICY CAREFULLY
          </p>
        </div>

        <section className="policy-section">
          <p>
            This Refund & Cancellation Policy applies to all premium plans purchased through:
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">goneet Website (Stripe)</li>
            <li className="policy-list-item">Android App (Stripe)</li>
            <li className="policy-list-item">iOS App (Apple In-App Purchase)</li>
          </ul>
        </section>

        {/* 1. General Policy */}
        <section className="policy-section">
          <h2>1. General Policy</h2>
          <p>
            All payments made for premium features are final and non-refundable,
            except when required by law or stated otherwise in this Policy.
          </p>
        </section>

        {/* 2. Stripe Payments */}
        <section className="policy-section">
          <h2>2. Stripe Payments (Website & Android App)</h2>
          <p>For payments made through Stripe:</p>

          <p>Refunds may be provided only in cases of:</p>
          <ul className="policy-list">
            <li className="policy-list-item">✔ Duplicate charges</li>
            <li className="policy-list-item">✔ Technical payment failures</li>
            <li className="policy-list-item">✔ Accidental multiple subscriptions</li>
            <li className="policy-list-item">✔ Service not delivered due to our system error</li>
          </ul>

          <p>Refunds are <strong>not</strong> provided for:</p>
          <ul className="policy-list">
            <li className="policy-list-item">• Change of mind</li>
            <li className="policy-list-item">• Incorrect plan selection</li>
            <li className="policy-list-item">• Partial usage of a subscription period</li>
          </ul>

          <p>
            Refund requests must be emailed to:
            <br />
            <strong>support@goneet.com</strong>
          </p>

          <p>We may ask for transaction details for verification.</p>
        </section>

        {/* 3. Apple IAP */}
        <section className="policy-section">
          <h2>3. Apple In-App Purchases (iOS App)</h2>
          <p>
            For purchases made via Apple IAP, <strong>all refunds are handled directly by Apple</strong>,
            not by goneet.
          </p>
          <p>Apple’s refund policy applies.</p>

          <p>To request a refund:</p>
          <p>
            Go to →{" "}
            <a
              href="https://reportaproblem.apple.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://reportaproblem.apple.com/
            </a>
            <br />
            Sign in → Select your goneet purchase → Request Refund
          </p>

          <p>We cannot issue iOS refunds from our side.</p>
        </section>

        {/* 4. Subscription Cancellations */}
        <section className="policy-section">
          <h2>4. Subscription Cancellations</h2>
          <p>You may cancel your subscription at any time.</p>

          <p>
            <strong>If purchased via Stripe (web/Android):</strong>
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">Cancel from your goneet account or Stripe billing portal.</li>
            <li className="policy-list-item">Your plan remains active until the end of the billing period.</li>
          </ul>

          <p>
            <strong>If purchased via Apple (iOS):</strong>
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">Cancel from your Apple ID subscription settings.</li>
            <li className="policy-list-item">Apple manages renewal cycles.</li>
          </ul>
        </section>

        {/* 5. Payment Disputes */}
        <section className="policy-section">
          <h2>5. Payment Disputes</h2>
          <p>
            If you believe you were charged incorrectly, please contact us immediately.
            Avoid filing unnecessary chargebacks as it may cause account restrictions.
          </p>
        </section>

        {/* 6. Changes to Policy */}
        <section className="policy-section">
          <h2>6. Changes to Refund Policy</h2>
          <p>
            We may update this Policy periodically.
            Updated versions will be posted with a new “Last Updated” date.
          </p>
        </section>

        {/* 7. Contact Us */}
        <section className="policy-section">
          <h2>7. Contact Us</h2>
          <p>For payment or refund-related questions:</p>
          <p><strong>Email:</strong> support@goneet.com</p>
        </section>
      </div>
    </Layout>
  );
};

export default CancellationRefundPolicyPage;
